<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import { IconType } from "$types/atoms";
  import Button from "$lib/atoms/Button.svelte";
  import { ButtonColor } from "$types/atoms";

  export let index = 0;
  export let total = 0;
  export let counterVisible = false;
  export let buttonColor: ButtonColor = ButtonColor.GRAY;
  export let disableButtonHoverAnimation = false;

  let y: number;

  const dispatch = createEventDispatcher();

  function onLeftClick() {
    dispatch("change", { direction: -1 });
  }

  function onRightClick() {
    dispatch("change", { direction: 1 });
  }
</script>

<nav>
  <div class="wrapper">
    <div class="counter type:label-fat" class:visible={counterVisible}>
      <span class="currentIndex">{(index + 1).toString().padStart(2, "0")}</span
      >
      <span class="divider"></span>
      <span class="totalIndex">{total.toString().padStart(2, "0")}</span>
    </div>
    <div class="btn btn--left" class:disabled={index === 0} style="color: red;">
      <Button
        icon={IconType.CHEVRON_LEFT}
        color={buttonColor}
        reduced
        {disableButtonHoverAnimation}
        on:click={onLeftClick}
        label="Previous item"
      />
    </div>
    <div
      class="btn btn--right"
      class:disabled={index + 1 === total}
      style="color: green;"
    >
      <Button
        icon={IconType.CHEVRON_RIGHT}
        color={buttonColor}
        reduced
        {disableButtonHoverAnimation}
        on:click={onRightClick}
        label="Next item"
      />
    </div>
  </div>
</nav>

<style lang="scss">
  .wrapper {
    display: flex;
  }

  .counter {
    margin: 0 fluid(34px, 34px);
    display: none;

    &.visible {
      display: flex;
      align-items: center;
    }
  }

  .btn--left {
    display: flex;
    justify-content: flex-end;
  }

  .divider {
    height: 80%;
    width: 1px;
    background: var(--color-stroke-dark-rgba);
    margin: 0 fluid(20px);
    display: inline-block;
  }

  .totalIndex {
    color: var(--color-stroke-dark-rgba);
  }

  .disabled {
    opacity: 0.3;
  }

  .btn--right {
    margin-left: 8px;
  }
</style>
